import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { siteNav } from "@/mocks/site";

export default function SiteHeader() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-night-900/90 backdrop-blur-md border-b border-night-700/60" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="group flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-cinnabar-600 text-parchment-100">
            <i className="ri-ghost-2-fill text-lg"></i>
          </span>
          <span className="leading-tight">
            <span className="hand-script block text-xl text-parchment-100">校园爆料</span>
            <span className="block text-[10px] tracking-[0.3em] text-parchment-300/70">怪谈求证 · 旧事档案</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {siteNav.map((item) => {
            const isActive = item.key === "home" ? pathname === "/" : pathname === item.path;
            return (
              <Link
                key={item.key}
                to={item.path}
                className={`relative whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  isActive ? "text-parchment-100" : "text-parchment-300/75 hover:text-parchment-100"
                }`}
              >
                {isActive && (
                  <span className="absolute inset-0 rounded-full bg-night-700/50 border border-night-600/40"></span>
                )}
                <span className="relative">{item.label}</span>
              </Link>
            );
          })}
          <Link
            to="/archive"
            className="ml-3 whitespace-nowrap rounded-md border border-cinnabar-500/70 bg-cinnabar-600/20 px-4 py-2 text-sm text-parchment-100 transition hover:bg-cinnabar-600"
          >
            进入档案库
          </Link>
        </nav>

        <button
          type="button"
          aria-label="展开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-night-600/60 text-parchment-200 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-night-700/60 bg-night-900/97 px-4 py-4 backdrop-blur-md md:hidden">
          <nav className="flex flex-col gap-1">
            {siteNav.map((item) => (
              <Link
                key={item.key}
                to={item.path}
                className="rounded-md px-3 py-2.5 text-parchment-200 hover:bg-night-700/50"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/archive"
              className="mt-2 whitespace-nowrap rounded-md border border-cinnabar-500/70 bg-cinnabar-600/20 px-3 py-2.5 text-center text-parchment-100"
            >
              进入档案库
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}